import type { Field } from '@atlassian/jira-issue-shared-types/src/common/types/field-type.tsx';
import getPendingValue, { getPendingAdfValue } from './get-pending-value.tsx';

/**
 * Returns the first available value for a given field.
 * editingValue => pendingValue => value
 */
const getEditingValue = (field: Field) =>
	typeof field.editingValue !== 'undefined' ? field.editingValue : getPendingValue(field);

export default getEditingValue;

/**
 * Returns the first available value for a given field.
 */
export const getEditingAdfValue = (field: Field) => field.editingValue || getPendingAdfValue(field);
